import { useSelector } from 'react-redux';
import UserLoopModal, {
  type UploadLoopData,
} from 'pages/AIMusicGenerator/components/Sidebar/components/UserLoopModal';
import { useSubscription } from 'services/hooks';
import { selectRemainingLoopUploads } from 'services/store/user/selectors';
import FreeLimitReachedModal from './FreeLimitReachedModal';
import PersonalLimitReachedModal from './PersonalLimitReachedModal';
import ProLimitReachedModal from './ProLimitReachedModal';

interface UserLoopModalContainerProps {
  open: boolean;
  onClose?: () => void;
  onUpload: (data: UploadLoopData) => void;
}

const UserLoopModalContainer = ({
  open,
  onClose,
  onUpload,
}: UserLoopModalContainerProps) => {
  const { isFreeAccount, isPersonalAccount, isProAccount } = useSubscription();

  const remainingLoopUploads = useSelector(selectRemainingLoopUploads);
  const { remaining = 0 } = remainingLoopUploads || {};

  if (remaining > 0) {
    return <UserLoopModal open={open} onClose={onClose} onUpload={onUpload} />;
  }

  if (isFreeAccount) {
    return <FreeLimitReachedModal open={open} onClose={onClose} />;
  }

  if (isPersonalAccount) {
    return <PersonalLimitReachedModal open={open} onClose={onClose} />;
  }

  if (isProAccount) {
    return <ProLimitReachedModal open={open} onClose={onClose} />;
  }

  return null;
};

export default UserLoopModalContainer;
